import React, {useEffect, useState} from "react";

const BlogCard = ({blog, index}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, index * 200);
        return () => clearTimeout(timer);
    }, [index]);

    return (
        <div
            className={`transform transition-all duration-700 ease-in-out ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
            } hover:scale-105 cursor-pointer overflow-hidden`}
        >
            <div className="blog-card">
                <a href={`article/${blog.id}`} className="block">
                    <div className="relative overflow-hidden">
                        <img
                            loading="lazy"
                            src={blog.url}
                            alt="Blog"
                            className="w-full object-cover"
                        />
                        <div className="absolute top-4 right-4 banner-btn text-white p-2">
                            <div className="text-2xl font-bold">{blog.date.split(" ")[0]}</div>
                            <div className="text-sm">{blog.date.split(" ")[1].toUpperCase()}</div>
                        </div>
                    </div>
                </a>
                <div className="blog-card-text">
                    <h3>
                        <a href={`article/${blog.id}`} className="blog-title">
                            {blog.title}
                        </a>
                    </h3>
                    <p>{blog.content}</p>
                    <a href={`article/${blog.id}`} className="read-more">
                        Read More <i className="las la-angle-double-right"></i>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;